import CSSecondaryButton, { CSSecondaryButtonProps } from "components/shared/button/CSSecondaryButton";
import React, { ReactNode } from "react";

import classNames from "classnames";

type CSResetButtonProps = Omit<CSSecondaryButtonProps, "children" | "buttonText"> & {
  buttonText?: ReactNode;
  isSubmitting?: boolean;
};

/**
 * Renders a button that is used for a reset button within a form.
 * See https://react-bootstrap.github.io/components/buttons/#api for props.
 */
const CSResetButton = ({
  className,
  type = "reset",
  buttonText = "Reset",
  isSubmitting = false,
  ...buttonProps
}: CSResetButtonProps) => {
  return (
    <CSSecondaryButton
      {...buttonProps}
      type={type}
      className={classNames("cs-reset-btn", className)}
      disabled={isSubmitting}
      buttonText={buttonText}
    />
  );
};

export default CSResetButton;
